import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { minifyCSS } from '../Conversion/Minifiers';
import RandomContent from '../Components/RandomContent';
import ConversionActions from "../Common/ConversionActions";
import { GetRandomBlogPost, GetPageContentBySlug } from "../services/apiservice";
import { useNavigate, useLocation } from "react-router-dom";

const CssMinifier = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
    const [tabSpace, setTabSpace] = useState(2);
    const [randomPost, setRandomPost] = useState('');
    const [loadingPost, setLoadingPost] = useState(true);
    const [pageContent, setpageContent] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const handleBlogClick = () => navigate('/blog/:paramlink');

    const paramlink = location.pathname.split('/').filter(Boolean).pop();

    useEffect(() => {
        fetchRandomPost();
        GetPageContent();
    }, []);

    const handleConversion = () => {
        const { minified, isError } = minifyCSS(inputData);
        setOutputData(minified);
        setIsError(isError);
    };

    const fetchRandomPost = async () => {
        setLoadingPost(true);
        try {
            const randomPostData = await GetRandomBlogPost();
            const jsonPostList = JSON.parse(randomPostData);
            setRandomPost(jsonPostList);
            setLoadingPost(false);
        } catch (error) {
            console.error("Error fetching the data:", error);
            setLoadingPost(false);
        }
    };

    const GetPageContent = async () => {
        if (paramlink) {
            try {
                const postMetaList = await GetPageContentBySlug(paramlink);
                const jsonMetaList = JSON.parse(postMetaList);
                setpageContent(jsonMetaList);
            } catch (error) {
                console.error("Error fetching the meta data:", error);
            }
        }
    };

    return (
        <>
            <div>
                <Header />


                <RandomContent />

                {/* Section 1 – Intro */}
                <div className="blog-area">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            <div className="full-col col-lg-12 col-md-12">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="details">
                                        <h4><a href="#">{pageContent?.section1header}</a></h4>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    pageContent?.section1text && pageContent.section1text.trim() !== ''
                                                        ? pageContent.section1text
                                                        : `Use our free CSS Minifier tool to compress your CSS code by removing whitespace, comments, and extra characters. Ideal for reducing file size and improving website performance. Fast, secure, and 100% client-side`,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tool */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">

                            {/* Input */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="thumb">
                                        <Inputs
                                            value={inputData}
                                            setValue={(val) => {
                                                setInputData(val);
                                                setIsError(false);
                                            }}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            lineCol={inputLnCol}
                                            setLineCol={setInputLnCol}
                                            readOnly={false}
                                            idPrefix="input"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Actions */}
                            <ConversionActions
                                tabSpace={tabSpace}
                                setTabSpace={setTabSpace}
                                handleConversion={handleConversion}
                                outputData={outputData}
                                randomPost={randomPost}
                                loadingPost={loadingPost}
                                handleBlogClick={handleBlogClick}
                                buttonLabel="Minify CSS"
                                iconClass="ri-exchange-line"
                            />

                            {/* Output */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                                    <div className="thumb">
                                        <Output
                                            value={outputData}
                                            setValue={setOutputData}
                                            lineCol={outputLnCol}
                                            setLineCol={setOutputLnCol}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            idPrefix="output"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 2 – Below Tool */}
                {pageContent?.section2text && pageContent.section2text.trim() !== '' && (
                    <div className="blog-area">
                        <div className="container-block-fluid">
                            <div className="row justify-content-center">
                                <div className="full-col col-lg-12 col-md-12">
                                    <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                        <div
                                            className="details"
                                            dangerouslySetInnerHTML={{ __html: pageContent.section2text }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Section 3 Below Boxes */}
                {pageContent?.section3text &&
                    pageContent.section3text.trim() !== "" && (
                        <div className="blog-area">
                            <div className="container-block-fluid">
                                <div className="row justify-content-center">
                                    <div className="full-col col-lg-12 col-md-12">
                                        <div
                                            className="single-blog-inner"
                                            data-aos="fade-up"
                                            data-aos-duration="2800"
                                        >
                                            <div className="details">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: pageContent.section3text,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

            </div>

            <Footer />
        </>
    );
};

export default CssMinifier;